export const camelToKebabConverter = (string) => {
    const result = string
        .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
        .toLowerCase();
    return result.startsWith('-') ? result.substr(1) : result;
};
//# sourceMappingURL=camelToKebab.js.map